import * as types from '../actions/semaphoreLocksActions';

const initialState = {
    semaphoreLocks: []
};

export default function semaphoreLocksReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_SEMAPHORE_LOCKS:
            return {
                ...state,
                semaphoreLocks: action.data.locks
            };
        default:
            return state;
    }
}